import { AccountCenterTableCell } from './AccountCenterTableCell';

export class AccountCenterTableRow {
  classes: {};

  constructor(private cells?: AccountCenterTableCell[], private cssClass?: string) {
    this.classes = {
      'account-center-table__row': true,
    };
    if (cssClass) {
      this.classes[cssClass] = true;
    }
  }

  appendCell(cell: AccountCenterTableCell) {
    this.cells.push(cell);
  }

  getCells(): AccountCenterTableCell[] {
    return this.cells;
  }

  getClasses() {
    return this.classes;
  }
}
